import { useApiQuery } from 'hooks/useApiQuery'

export const useGetGroupPermission = () => {
  return useApiQuery({
    path: '/grouppermission',
    method: 'get',
    queryKey: ['/grouppermission'],
    queryArgs: {},
  })
}
